function ProtocalError (code, msg, data) {
  this.code = code || '0';
  this.msg = msg || '系统错误';
  this.originData = data;
  this.stack = (new Error()).stack;
}

ProtocalError.prototype = Object.create(Error.prototype);
ProtocalError.prototype.constructor = ProtocalError;

export default ProtocalError;